import { useState } from 'react'
import type { JSX } from 'react'

import { ContentItemDetailsCard } from '~publish/components/ContentItemCard'
import type { ContentItemDraft } from '~publish/components/ContentItemCard'
import { isOfType } from '~publish/helpers/typeGuards'

import { ContentItemCalendarItemView } from './ContentItemCalendarItemView'

/**
 * A channel-less draft placed in a calendar day/hour cell by its target date.
 * Read-only re: scheduling — no drag handle. Clicking opens
 * {@link ContentItemPopover} for the preview and actions.
 */
export function ContentItemCalendarItem({
  contentItem,
  condensed = false,
}: {
  contentItem: ContentItemDraft
  condensed?: boolean
}): JSX.Element | null {
  const [isOpen, setIsOpen] = useState(false)

  const body = isOfType(contentItem.body, 'DraftContent')
    ? contentItem.body
    : null
  if (!body) return null

  return (
    <ContentItemCalendarItemView
      text={body.text}
      condensed={condensed}
      preview={<ContentItemDetailsCard contentItem={contentItem} />}
      isOpen={isOpen}
      onOpenChange={setIsOpen}
    />
  )
}
